<div class="dialog-header">
  <h2>Attendance History</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <table>
    <thead>
      <tr>
        <th>Attendance Date</th>
        <th>Attendance Location</th>
        <th>Attendance Creator</th>
        <th>Attendance On</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of dataSource">
        <td>{{ row.attendanceDate }}</td>
        <td>{{ row.attendanceLocation }}</td>
        <td>{{ row.attendanceCreator }}</td>
        <td>{{ row.attendanceOn }}</td>
      </tr>
      <tr *ngIf="dataSource.length === 0">
        <td colspan="4" class="empty">No records found.</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
</div>
